import React, { createContext, useCallback, useContext, useState } from 'react';
import Snackbar from '@mui/material/Snackbar';
import Alert from '@mui/material/Alert';
import { getGlobalSettings } from '../services/apiService';

const NotificationContext = createContext();

export function useNotification() {
  return useContext(NotificationContext);
}

export function NotificationProvider({ children }) {
  const [notification, setNotification] = useState({ message: '', severity: 'success', open: false });

  const showNotification = useCallback(async (message, severity = 'success') => {
    try {
      // Check global settings for in-app notifications
      const globalSettings = await getGlobalSettings();
      const shouldShowNotifications = globalSettings.inAppNotifications !== false; // Default to true
      
      if (!shouldShowNotifications) {
        return;
      }
      
      setNotification({ message, severity, open: true });
      setTimeout(() => {
        setNotification(n => ({ ...n, open: false }));
      }, 7000);
    } catch (error) {
      // Default to showing notification if we can't get settings
      setNotification({ message, severity, open: true });
      setTimeout(() => {
        setNotification(n => ({ ...n, open: false }));
      }, 7000);
    }
  }, []);

  const handleClose = (event, reason) => {
    if (reason === 'clickaway') return;
    setNotification(n => ({ ...n, open: false }));
  };

  return (
    <NotificationContext.Provider value={{ showNotification }}>
      {children}
      <Snackbar
        open={notification.open}
        autoHideDuration={7000}
        onClose={handleClose}
        anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
      >
        <Alert onClose={handleClose} severity={notification.severity} sx={{ width: '100%' }}>
          {notification.message}
        </Alert>
      </Snackbar>
    </NotificationContext.Provider>
  );
} 